export const TEMU_COLOR = '#FB7701';
